export default "__VITE_ASSET__MH5i302___"